var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"row landscape-modal\"\u003E\u003Cdiv class=\"close-landscape-modal fa fa-times\" ng-click=\"close()\"\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"row-fluid\" id=\"landscape-form\"\u003E\u003Cdiv class=\"col-xs-12 window-height\"\u003E\u003Clandscape-form questions=\"landscapeQuestions\" contract-selected=\"contract\" display-end-modal=\"false\"\u003E\u003C\u002Flandscape-form\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/states/subscription/modal/landscapeModal.jade
// module id = 1178
// module chunks = 1